<template>
    <div :id="{page:inModal!=true}">
        <div  :class="{pageContent:inModal!=true}">
            <div class="page-title page-title-small" v-if="inModal!=true">
                <h2><button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>ثبت نوع کار </h2>
                <button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-22 fa fa-redo"></i></button>
            </div>
            <div class="card header-card shape-rounded" data-card-height="150" v-if="inModal!=true">
                <div class="card-overlay bg-highlight opacity-95"></div>
                <div class="card-overlay dark-mode-tint"></div>
                <div class="card-bg bg-20"></div>
            </div>
            <div class="card card-style overflow-visible">
                <div class="content mb-0">

                    <div class="input-style input-style-2 has-icon input-required">
                        <i class="input-icon fa fa-check color-magenta2-light"></i>
                        <span class="color-highlight" :class="{'input-style-1-active' : taskTypeModel.title!==null}">عنوان</span>
                        <input class="form-control" type="text" v-model="taskTypeModel.title" @input="v$.taskTypeModel.title.$touch()" :class="{invalid:v$.taskTypeModel.title.$error}">
                        <p class="text-danger" v-if="v$.taskTypeModel.title.required.$invalid && v$.taskTypeModel.title.$dirty">لطفا عنوان را وارد کنید.</p>
                    </div>

                    <div class="mb-3">
                        <v-select dir="rtl" label="title" placeholder="پست سازمانی مرتبط" :filterable="false" :searchable="false" multiple chips :options="OrgJobList" :reduce="p => p.orgJobId" v-model="taskTypeModel.OrgJobIdList">
                            <template slot="option"  >
                                <div class="d-center">
                                    {{ option.title }}
                                </div>
                            </template>
                        </v-select>
                        <p class="text-danger" v-if="v$.taskTypeModel.OrgJobIdList.required.$invalid && v$.taskTypeModel.OrgJobIdList.$dirty">لطفا پست سازمانی مرتبط را وارد کنید.</p>
                    </div>

                    <button :disabled="Loading" class="btn btn-xxs mt-2 mb-4 btn-full bg-green1-dark rounded-sm font-900 w-100" @click.prevent="CreateTaskType">
                        <i class="fa fa-check font-10 ml-2"></i>
                        ثبت
                    </button>
                </div>
            </div>
        </div>
        <transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
            <div v-if="Loading" class="w-100 d-flex justify-content-center loadingBox">
                <div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10"><i class="fa fa-sync fa-spin ml-3"></i>درحال ارسال اطلاعات ...</div>
            </div>
        </transition>
    </div>
</template>
<script>
import useVuelidate from '@vuelidate/core'
    import {
        required
    } from "@vuelidate/validators";
    import 'vue-select/dist/vue-select.css';

    export default {
        props: ['inModal'],
        setup: () => ({ v$: useVuelidate() }),
        data() {
            return {
                taskTypeModel: {
                    code: "",
                    title: null,
                    taskTypeId: 0,
                    userId: 0,
                    strOrgJobId: "",
                    OrgJobIdList:[]
                },

            };
        },
        computed: {
            Loading() {
                return this.$store.getters.GetLoading;
            },
            OrgJobList() {
                return this.$store.getters.GetOrgJobList;
            },
           
        },
        watch: {
            OrgJobList: function () {
                console.log(this.OrgJobList.length);
                if (this.OrgJobList.length == 1) {
                    var jobId = this.OrgJobList[0].orgJobId;
                    console.log(jobId);
                    this.taskTypeModel.OrgJobIdList.push(jobId);
                }
            },
          
        },
        created() {
            this.GetOrgJobList();
        },
        methods: {
            GetOrgJobList() {
                this.$store.dispatch("GetOrgJobListFromServer");

            },
            CreateTaskType() {
                this.v$.$touch(); //it will validate all fields
                if (!this.v$.$invalid) { //invalid, becomes true when a validations return false
                    this.taskTypeModel.strOrgJobId = this.taskTypeModel.OrgJobIdList.toString();
                    this.$http.post('Task/TaskTypeCreate', this.taskTypeModel).then(response => {
                        if (response.status == 400 || response.data.success == false) {
                            var res = response.data.errors.map(a => a.errorMessage);
                            this.showSuccessMessage(res.join('\n'));
                        }
                        else {
                            if (this.inModal == true) {
                                this.showSuccessMessage("با موفقیت ثبت شد");
                                this.$emit('close');
                            }
                            else {
                                this.$router.go(-1);
                            }

                        }
                        this.$store.dispatch("GetTaskTypeListFromServer");
                    }, error => {
                        console.log(error);
                    });
                }

            },
           
        },

        validations: {
            taskTypeModel: {
                title: {
                    required
                },
                OrgJobIdList: {
                    required
                },
               
            }


        },
       
    };
</script>
